
import $ from "jquery";
import filters from "@/filters";
import Vue from "vue";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import { FAQCategoryModel, FAQModel } from "@/models/faq.model";

@Component({
  filters: filters,
})
export default class FAQList extends Vue {
  /* VUEX */

  // ACTIONS
  @Action("actionSelectFAQByCategory", { namespace: "faq" })
  private actionSelectFAQByCategory: any;
  @Action("actionSetCategory", { namespace: "faq" })
  private actionSetCategory: any;

  // STATE
  @State("locale")
  private locale!: string;
  @State("array_faq", { namespace: "faq" })
  private array_faq: Array<FAQCategoryModel>;
  @State("array_faq_category", { namespace: "faq" })
  private array_faq_category: Array<FAQModel>;
  @State("selected_category", { namespace: "faq" })
  private selected_category: FAQCategoryModel;

  /* METHODS */
  private isActive(category: any) {
    if (this.selected_category) {
      return category.id === this.selected_category.id;
    }
    return false;
  }

  private toggleFaq(index: number) {
    if ($(`#icon-${index}`).hasClass("rotateIcon")) {
      $(`#title-${index}`).removeClass("titleActive");
      $(`#icon-${index}`).removeClass("rotateIcon");
      $(`#decs-${index}`).hide();
    } else {
      $(`#title-${index}`).addClass("titleActive");
      $(`#icon-${index}`).addClass("rotateIcon");
      $(`#decs-${index}`).show();
    }
  }

  private clickDetail(category: any, index?: number) {
    $(`.Title`).removeClass("titleActive");
    $(`.IconArrow`).removeClass("rotateIcon");
    $(`.decs`).hide();

    this.actionSetCategory({ category });
    this.actionSelectFAQByCategory({ id: category.id });

    if (!$(`#titleCategory-${index}`).hasClass("titleActive")) {
      $(`.title`).removeClass("titleActive DBold");
      $(`#titleCategory-${index}`).addClass("titleActive");
    }
  }

  private getName(category: any) {
    if (this.locale === "id") {
      return category.name_ind;
    }
    return category.name_en;
  }

  private getTranslationTitle(faq: any) {
    if (this.locale == "id") {
      return faq.title_ind;
    }
    return faq.title_en;
  }

  private getTranslationDescription(faq: any) {
    if (this.locale == "id") {
      return faq.description_ind;
    }
    return faq.description_en;
  }
}
